// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import segmentSceneMng from './metaData/segmentScene'
export default {
  state: segmentSceneMng,
  actions
}
